import { render, staticRenderFns } from "./BaseInfoBanner.vue?vue&type=template&id=5b54fc7c&scoped=true"
import script from "./BaseInfoBanner.vue?vue&type=script&lang=js"
export * from "./BaseInfoBanner.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoBanner.vue?vue&type=style&index=0&id=5b54fc7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b54fc7c",
  null
  
)

export default component.exports